import { useUser } from '@auth-v2';
import { useForm } from 'react-hook-form';

import { useUserName } from '@queries';
import { Modal, ModalProps, Button, Text, Input, Stack, Inline, u } from '@ui';

type FormValues = {
    confirmation: string;
};

export type DeleteActivityModalProps = Pick<ModalProps, 'onDismiss' | 'open'> & {
    activityDate: string;
    ownerId: string;
    onConfirm: () => void;
};

export const DeleteActivityModal = ({
    onConfirm,
    onDismiss,
    ownerId,
    open,
    activityDate,
}: DeleteActivityModalProps) => {
    const { register, handleSubmit, watch } = useForm<FormValues>({
        mode: 'onChange',
        defaultValues: {
            confirmation: '',
        },
    });
    const { data: user } = useUser();
    const activeUserIsOwner = user?.id === ownerId;
    const { data: studentName } = useUserName(ownerId);

    const confirmationValue = watch('confirmation');

    const isConfirmed = confirmationValue?.trim().toLowerCase() === 'yes';

    const onSubmit = () => {
        if (!isConfirmed) return;
        onConfirm();
        onDismiss();
    };
    if (!open) {
        return null;
    }
    return (
        <Modal
            title="Delete Activity"
            variant="partial"
            footer={{
                primary: (
                    <Button variant="destroy" onClick={handleSubmit(onSubmit)} isDisabled={!isConfirmed}>
                        Delete
                    </Button>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss}>
                        Cancel
                    </Button>
                ),
            }}
            open={open}
            onDismiss={onDismiss}
        >
            <Stack gap={u(2)} mb={u(2.5)}>
                <Text variant="p">Are you sure you want to delete activity from {activityDate}</Text>
                {!activeUserIsOwner ? (
                    <Text variant="p">
                        <strong>Attention</strong> you are deleting an activity from <strong>{studentName}</strong>
                    </Text>
                ) : (
                    ''
                )}
                <Text variant="p">
                    Type <strong>yes</strong> in the input below to enable deletion.
                </Text>
                <Inline mt={u(1)}>
                    <Input placeholder="Type yes to confirm" {...register('confirmation')} />
                </Inline>
            </Stack>
        </Modal>
    );
};
